import React, { forwardRef } from 'react';
import * as Styled from './Button.styles';
/**
 * Mui Button component with additional colours
 */
export const Button = forwardRef(function Button({ color, dataCy, ...otherProps }, ref) {
    //if color is supported by Mui Button let it handle it else let the extended component handled it
    const colorVariant = color === 'secondary' ? { color: color } : { palettekey: color };
    return (React.createElement(Styled.Button, { ref: ref, "data-cy": dataCy, ...otherProps, ...colorVariant }));
});
export default Button;
